const AssetPageFeatureUrls = {
  ACCORDION: 'accordion',
  APP_INTEGRATION: 'plugin',
  BANNER: 'banner',
  CALENDAR: 'calendar',
  CAROUSEL: 'carousel',
  COUNTDOWN: 'countdown',
  FOOTER: 'footer',
  FORM: 'form',
  GALLERY: 'gallery',
  HEADER: 'header',
  IMAGE: 'image',
  LOGO: 'logo',
  MAP: 'map',
  MENU: 'menu',
  NEWS: 'news',
  PAGINATION: 'pagination',
  PARALLAX: 'parallax',
  PRICING_TABLE: 'pricing-table',
  SLIDER: 'slider',
  SOCIAL: 'social',
  TABLE: 'table',
  VIDEO: 'video',
  WEATHER: 'weather'
};
export default AssetPageFeatureUrls;